import React, { useEffect, useState } from "react";
import socket from "../../socket";
import { CampaignsDataType } from "../../type";
import { useNavigate } from "react-router-dom";
import { IoMdChatboxes } from "react-icons/io";

export default function CampaignList() {
  const [campaigns, setCampaigns] = useState<CampaignsDataType[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const handleInitialize = (resp: any) => {
      setCampaigns(resp?.campaigns);
      setTimeout(() => setIsLoading(false), 500);
      if ((resp?.isMultipleCampaign ?? false) === false && resp?.notInCampaign === false) {
        navigate("/chat-box", { state: {...resp?.campaigns[0],isMultipleCampaign: resp?.isMultipleCampaign, } });
      }
    };
    
    socket.emit("Initialize");
    socket.on("Initialize", handleInitialize);

    return () => {
      socket.off("Initialize");
    };
    // eslint-disable-next-line
  }, []);

  return (
    <div className="container-fluid">
      <div className="card mt-4">
        <div className="card-header bg-white p-3 d-md-flex justify-content-md-between align-items-center">
          <h2 className="w-100 mb-md-2 mb-3">Campaigns</h2>
        </div>
        <div className="card-body  p-0">
          <div className="table-responsive">
            <table className="table table-hover table-bordered text-nowrap">
              <thead>
                <tr>
                  <th className="ps-3 sr-no">SR No</th>
                  <th className="text-center">Name</th>
                  <th className="text-center action">Actions</th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <tr>
                    <td colSpan={3} height={100}>
                      <div className="text-center">
                        <div className="loader"></div>
                      </div>
                    </td>
                  </tr>
                ) : campaigns.length !== 0 ? (
                  campaigns.map((item, i) => (
                    <tr key={i}>
                      <td> {i + 1}</td>
                      <td>{item?.name}</td>
                      <td>
                        <div className="w-100 d-flex justify-content-center">
                          <IoMdChatboxes
                            className="h4 mb-0 cursor-pointer"
                            onClick={() =>
                              navigate("/chat-box", { state: {...item, isMultipleCampaign:true} })
                            }
                          />
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={3} className="text-center">
                      You are not in any campaign
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
